export default "__VITE_ASSET__e0411018__"